import React from 'react';
import SplatterLoading from '../components/SplatterLoading';

const LoadingDemo = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="container mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold text-lime-400 text-center mb-12">
          Splatter Loading Animations 🎨
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Inline Loading */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8">
            <h2 className="text-xl font-semibold text-white mb-4">Inline Loading</h2>
            <p className="text-zinc-400 mb-6 text-sm">
              Used for loading states within components (like checking availability times)
            </p>
            <SplatterLoading message="Checking availability..." />
          </div>

          {/* Different Message */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8">
            <h2 className="text-xl font-semibold text-white mb-4">Custom Message</h2>
            <p className="text-zinc-400 mb-6 text-sm">
              Dynamic loading messages based on context
            </p>
            <SplatterLoading message="Getting your fresh cut ready..." />
          </div>
        </div>

        <div className="mt-12 bg-zinc-900 border border-lime-500/30 rounded-lg p-8">
          <h2 className="text-xl font-semibold text-white mb-4">Features</h2>
          <ul className="space-y-3 text-zinc-300">
            <li className="flex items-start">
              <span className="text-lime-400 mr-2">✓</span>
              <span>Animated purple drip effect in the center with pulsing splatter</span>
            </li>
            <li className="flex items-start">
              <span className="text-lime-400 mr-2">✓</span>
              <span>Orbiting purple and lime green splatter dots (4 total, rotating continuously)</span>
            </li>
            <li className="flex items-start">
              <span className="text-lime-400 mr-2">✓</span>
              <span>Glowing effects matching your brand colors</span>
            </li>
            <li className="flex items-start">
              <span className="text-lime-400 mr-2">✓</span>
              <span>Animated text with bouncing dots</span>
            </li>
            <li className="flex items-start">
              <span className="text-lime-400 mr-2">✓</span>
              <span>Works inline or full-screen mode</span>
            </li>
          </ul>
        </div>

        <div className="mt-8 text-center">
          <p className="text-zinc-500 text-sm">
            The splatter animation appears whenever data is loading: initial page load, availability checks, etc.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingDemo;
